import React from "react";
import PropTypes from "prop-types";
import { PartnerWrapper } from "./style";
import { CtaButton } from "../../Elements";

const Partner = (props) => {
	const { firstHeading, description, secondHeading, textWithUrl, cta } = props;

	return (
		<PartnerWrapper>
			<div className="jobOpenings">
				<div className="openingsHeading">{firstHeading}</div>
				<div className="description">{description}</div>
				{cta && (
					<div className="ctaWrapper">
						<CtaButton cta={cta} />
					</div>
				)}
			</div>
			<div className="partnership">
				<div className="partnershipHeading">{secondHeading}</div>
				<div className="partnerContainer">
					<div className="textContainer">
						{textWithUrl.map((data, index) => (
							<div key={index} className="textWrapper">
								<div className="partnershipText">{data?.text}</div>
								<div className="urlContainer">
									<div className="textWithUrl">
										<a href={data?.link[0]?.link?.link}>
											{data?.link[0]?.label}
										</a>
									</div>
								</div>
							</div>
						))}
					</div>
				</div>
			</div>
		</PartnerWrapper>
	);
};

Partner.propTypes = {
	firstHeading: PropTypes.string,
	description: PropTypes.string,
	secondHeading: PropTypes.string,
	textWithUrl: PropTypes.array,
	cta: PropTypes.shape({
		link: PropTypes.shape({
			type: PropTypes.oneOf(["hash", "external", "internal"]),
			value: PropTypes.string,
		}),
		color: PropTypes.string,
		type: PropTypes.oneOf(["solid", "outline"]),
		text: PropTypes.string,
	}),
};

Partner.defaultProps = {
	firstHeading: "",
	description: "",
	secondHeading: "",
	textWithUrl: [],
	cta: null,
};

export default Partner;
